import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface UpdateCustomerRequest {
    status?: boolean;
    customer_name?: string;
    customer_post?: string;
    customer_address?: string;
    customer_address_detail?: string;
    manager_name?: string;
    manager_mobile?: string;
    manager_email?: string;
}

export const usePutCustomerInfo = (
    successCallback?: () => void,
): UseMutationResult<null, Error, { id: number; data: UpdateCustomerRequest }, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, { id: number; data: UpdateCustomerRequest }>({
        mutationFn: async ({ id, data }: { id: number; data: UpdateCustomerRequest }) => {
            const response = await axios.put(`${enum_api_uri.put_customer}/${id}`, data, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
        onSuccess: (data, variables) => {
            const customerId = variables.id;
            queryClient.invalidateQueries({ queryKey: ["getCustomerList"] });
            queryClient.invalidateQueries({ queryKey: ["getCustomerInfo", customerId] });
            successCallback?.();
        },
    });
};
